import React from "react";

// eslint-disable-next-line react/display-name
const withLayout = (Layout, Component) => ({ ...props }) => {
  return (
    <Layout>
      <Component {...props} />
    </Layout>
  );
};

export default withLayout;
